/*******************************************************************************
 * Copyright     : Copyright (c)  2021 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : FilesTable.tsx
 *
 * Project Title : APM Settings Tool
 *
 * Description   : ConfigTable component
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H422335
 *
 * @Date         : Jan 28th, 2022
 *
 * @Version      : Version 1.0
 *
 * By            : <Changed By user id>
 * On            :  <Change Date>
 * Description   : <Change Description>
 *
 *
 ******************************************************************************/

import React, { FC } from "react";
import { Card, Grid, Icon, Button } from "@scuf/common";
import { useDispatch } from "react-redux";
import { setShowAccountModal } from "stores/UIStore";
import "./NoCustomerAccountSelected.scss";

export const NoCustomerAccountSelected: FC = () => {
  const dispatch = useDispatch();

  const onShowAccountModal = () => {
    dispatch(setShowAccountModal(true));
  };
  return (
    <Card className="no-customer-account">
      <Card.Content>
        <Grid>
          <Grid.Row>
            <Grid.Column className="no-customer-account-icon-container">
              <Icon root="common" name="user-search" size="large" />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column className="no-customer-account-text">
              {`No customer account selected. Please `}
              <Button
                onClick={onShowAccountModal}
                type="link"
                content={`Click here`}
                className="show-account-modal-link"
              />
              {`to select a customer account.`}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Card.Content>
    </Card>
  );
};
